import validationConf from '../config/validation';

const isEmailValid = email => {
  // eslint-disable-next-line
  const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regularExpression.test(email);
};

const validationLogin = (data) => {
  const error = {};
  let isError = false;
  if (!data.email.trim()) {
    error.email = 'Enter email';
    isError = true;
  }

  if (data.password && data.password.trim().length === 0) {
    error.password = 'Enter password';
    isError = true;
  }
  return {error, isError}
};

const validationRegister = (data) => {
  const error = {};
  let isError = false;

  if (!isEmailValid(data.email.trim())) {
    error.email = 'Not correct email';
    isError = true;
  }

  if (data.name.trim().length === 0) {
    error.name = 'Add name';
    isError = true;
  }

  if (!data.companyName){
    error.companyName = 'Add company name';
    isError = true;
  }

  if (data.password.trim().length === 0) {
    error.password = 'Not correct password';
    isError = true;
  }

  if (data.password.trim().length < 6) {
    error.password = 'Min length 6';
    isError = true;
  }

  if (data.confirmPassword.trim().length === 0) {
    error.confirmPassword = 'Not correct password';
    isError = true;
  }

  if (data.confirmPassword.trim() !== data.password.trim()) {
    error.confirmPassword = 'Passwords does not match';
    isError = true;
  }

  return {error, isError}
};


const validationCustomerRegister = (data) => {
  const error = {};
  let isError = false;

  if (!isEmailValid(data.email.trim())) {
    error.email = 'Not correct email';
    isError = true;
  }

  if (data.name.trim().length === 0) {
    error.name = 'Add name';
    isError = true;
  }

  if (data.lastName.trim().length === 0) {
    error.lastName = 'Add Last Name';
    isError = true;
  }

  if (!data.phone){
    error.phone = 'Add Phone';
    isError = true;
  }

  if (data.password.trim().length === 0) {
    error.password = 'Not correct password';
    isError = true;
  }

  if (data.password.trim().length < 6) {
    error.password = 'Min length 6';
    isError = true;
  }

  if (data.confirmPassword.trim().length === 0) {
    error.confirmPassword = 'Not correct password';
    isError = true;
  }

  if (data.confirmPassword.trim() !== data.password.trim()) {
    error.confirmPassword = 'Passwords does not match';
    isError = true;
  }

  return {error, isError}
};

const validationTourData = (data) => {
  const error = {};
  let isValid = true;
  if(!data.title || data.title.length === 0) error.title = 'Create tour title';
  if(data.title && data.title.length > 300) error.title = 'The maximum length is 500 characters';
  if(data.description && data.description.length > 2500) error.description = 'The maximum length is 2500 characters';
  if(!data.description || data.description.length === 0) error.description = 'Add tour description';
  if(!data.cityId) error.cityId = 'Select city';
  if(!data.address) error.address = 'Add tour address';
  if(data.tourDates.length === 0) error.tourDates = 'Add tour schedule';
  if(data.images && data.images.length === 0) error.images = 'Add image';
  if(data.tourPhotos && data.tourPhotos.length === 0) error.images = 'Add image';
  if(+data.priceOnePerson === 0) error.priceOnePerson = 'Enter price by person';
  if(+data.minPersons === 0) error.minPersons = 'Enter min persons';
  if(+data.maxPersons === 0) error.maxPersons = 'Enter max persons';
  if(+data.maxPersons < +data.minPersons) error.maxPersons = 'Min is more then max';

  const errorKeys =  Object.keys(error);
  if(errorKeys.length !== 0){
    isValid = false;
  }
  return {error, isValid}
};

const validateContactUs = (d) => {
  const err = {};

  let isValid = true;
  if (!d.name) err.name = 'Add your name';
  else if (d.name.length > 100) err.name = 'Max length 100';

  if(!d.email) err.email = 'Add your email';
  else if (d.email.length > 100) err.email = 'Max length 100';
  else if (!isEmailValid(d.email.trim())) err.email = 'Email is not valid';

  if(!d.text) err.text = 'Add message';
  else if (d.text.length > 1000) err.text = 'Max length 1000'

  const errorKeys =  Object.keys(err);
  if(errorKeys.length !== 0){
    isValid = false;
  }
  return {error: err, isValid}
};

const validateVideo = (file) => {
  let error = '';
  let isValid = true;

  if (file.size > validationConf.MAX_VIDEO_SIZE * 1000000) {
    error = `Max size of video is ${validationConf.MAX_VIDEO_SIZE} Mb,
         The size of the video ${file.name} 
         is ${(file.size / 1000000).toFixed(2)} Mb`;
    isValid = false;
  }
  if (!validationConf.VIDEO_FORMAT[file.type.split('/')[1]]) {
    error = `Acceptable video formats is ${Object.keys(validationConf.VIDEO_FORMAT).join(', ')}`;
    isValid = false;
  }
  return {error, isValid}
};

const validateImages = (images, countImages) => {
  let error = '';
  let isValid = true;

  if (images.length + countImages > validationConf.MAX_NUMBER_OF_IMAGES) {
    error = `The maximum number of images is ${validationConf.MAX_NUMBER_OF_IMAGES}`;
    isValid = false;
  }

  for (let i = 0; i < images.length; i++) {
    if (images[i].size > validationConf.MAX_IMAGE_SIZE * 1000000) {
      error = `Max size of image is ${validationConf.MAX_IMAGE_SIZE},
               The size of the image ${images[i].name} 
               is ${(images[i].size / 1000000).toFixed(2)} Mb`;
      isValid = false;
    }
  }
  return {error, isValid}
};

const validateEditProfile = (data) => {
  const error = {};
  let isValid = true;

  if (data.name.length < 1) {
    error.name = 'At least one character';
    isValid = false;
  }
  if (data.name.length > 100) {
    error.name = 'Maximum number of characters 100';
    isValid = false;
  }
  if (data.lastName.length > 100) {
    error.lastName = 'Maximum number of characters 100';
    isValid = false;
  }
  if (data.phone.length < 5) {
    error.phone = 'At least 5 character';
    isValid = false;
  }
  if (data.phone.length > 50) {
    error.phone = 'Maximum number of characters 50';
    isValid = false;
  }

  return {error, isValid}
};

/**
 * Check value for type number
 * */
const isFieldPrice = (value, prevValue) => {

    if (value && Number.isNaN(value)) {
      // console.log(1)
      return prevValue || '';
    }
    if (value.length > 10) {
      // console.log(2)
      return prevValue || '';
    }
    const regex = /^[0-9]\d*(?:\.\d{0,2})?$/;

    if (value && value !== '0' && value !== '0.')
      if (!regex.test(value)) {
        // console.log(3)
        return prevValue || '';
      }
    return value;
  }
;

export {
  isEmailValid,
  validationLogin,
  validationRegister,
  validationCustomerRegister,
  validationTourData,
  validateVideo,
  validateImages,
  validateEditProfile,
  isFieldPrice,
  validateContactUs,
};



// WEBPACK FOOTER //
// ./src/app/utils/validationUtils.js